import React from 'react'

import useStyles from './styles'

const ContentSection = ({
  values,
  kb_titleRef,
  kb_introRef,
  kb_send_messageRef,
  kb_article_nameRef,
  kb_article_name_pluralRef,
  online_introRef,
  offline_introRef,
  offline_intro_endRef,
  m_offline_introRef,
  m_offline_intro_endRef,
  offline_submitRef,
  setChanged
}) => {
  const classes = useStyles()
  const checkValue = (value, ref) => {
    if (ref.current?.value !== null && value !== ref.current?.value) {
      setChanged(true)
    }
  }

  return (
    <>
      <section className={classes.inputSection}>
        <label htmlFor='kb_title'>Title</label>
        <input
          placeholder='Welcome to SonarCX!'
          name='kb_title'
          defaultValue={values.widget_config?.messages?.kb_title}
          ref={kb_titleRef}
          maxLength={50}
          onBlur={() =>
            checkValue(values.widget_config?.messages?.kb_title, kb_titleRef)
          }
        />
      </section>

      <section className={classes.multiLineSection}>
        <label htmlFor='kb_intro'>Intro Text</label>
        <textarea
          placeholder='The right solution for your business and customers.'
          name='kb_intro'
          rows={4}
          defaultValue={values.widget_config?.messages?.kb_intro}
          ref={kb_introRef}
          maxLength={300}
          onBlur={() =>
            checkValue(values.widget_config?.messages?.kb_intro, kb_introRef)
          }
        />
      </section>

      <section className={classes.multiLineSection}>
        <label htmlFor='kb_send_message'>Send Message</label>
        <textarea
          placeholder={`Please leave us your information and we'll get back to you soon.`}
          name='kb_send_message'
          rows={4}
          defaultValue={values.widget_config?.messages?.kb_send_message}
          ref={kb_send_messageRef}
          maxLength={300}
          onBlur={() =>
            checkValue(
              values.widget_config?.messages?.kb_send_message,
              kb_send_messageRef
            )
          }
        />
      </section>

      <section className={classes.inputSection}>
        <label htmlFor='kb_article_name'>Article Name</label>
        <input
          placeholder='FAQ'
          name='kb_article_name'
          defaultValue={values.widget_config?.messages?.kb_article_name}
          ref={kb_article_nameRef}
          maxLength={20}
          onBlur={() =>
            checkValue(
              values.widget_config?.messages?.kb_article_name,
              kb_article_nameRef
            )
          }
        />
      </section>

      <section className={classes.inputSection}>
        <label htmlFor='kb_article_name_plural'>Article Name (plural)</label>
        <input
          placeholder='FAQs'
          name='kb_article_name_plural'
          defaultValue={values.widget_config?.messages?.kb_article_name_plural}
          ref={kb_article_name_pluralRef}
          maxLength={20}
          onBlur={() =>
            checkValue(
              values.widget_config?.messages?.kb_article_name_plural,
              kb_article_name_pluralRef
            )
          }
        />
      </section>

      <section className={classes.multiLineSection}>
        <label htmlFor='online_intro'>Online Intro</label>
        <textarea
          placeholder={`Hi, There! I'm your Personal Assistant here.

Before we start, let's cover some basics.`}
          name='online_intro'
          rows={4}
          defaultValue={values.widget_config?.messages?.online_intro}
          ref={online_introRef}
          maxLength={300}
          onBlur={() =>
            checkValue(
              values.widget_config?.messages?.online_intro,
              online_introRef
            )
          }
        />
      </section>

      <section className={classes.multiLineSection}>
        <label htmlFor='offline_intro'>Offline Intro</label>
        <textarea
          placeholder={`Hello, leave us your details and we will get right back to you.`}
          name='offline_intro'
          rows={4}
          defaultValue={values.widget_config?.messages?.offline_intro}
          ref={offline_introRef}
          maxLength={300}
          onBlur={() =>
            checkValue(
              values.widget_config?.messages?.offline_intro,
              offline_introRef
            )
          }
        />
      </section>

      <section className={classes.multiLineSection}>
        <label htmlFor='offline_intro_end'>Offline Intro End</label>
        <textarea
          placeholder=''
          name='offline_intro_end'
          rows={4}
          defaultValue={values.widget_config?.messages?.offline_intro_end}
          ref={offline_intro_endRef}
          maxLength={300}
          onBlur={() =>
            checkValue(
              values.widget_config?.messages?.offline_intro_end,
              offline_intro_endRef
            )
          }
        />
      </section>

      <section className={classes.multiLineSection}>
        <label htmlFor='m_offline_intro'>Offline Intro (for mobile)</label>
        <textarea
          placeholder='Hello, leave us your details and we will get right back to you.'
          name='m_offline_intro'
          rows={4}
          defaultValue={values.widget_config?.messages?.m_offline_intro}
          ref={m_offline_introRef}
          maxLength={300}
          onBlur={() =>
            checkValue(
              values.widget_config?.messages?.m_offline_intro,
              m_offline_introRef
            )
          }
        />
      </section>

      <section className={classes.multiLineSection}>
        <label htmlFor='m_offline_intro_end'>
          Offline Intro End (for mobile)
        </label>
        <textarea
          placeholder='Have a good day!'
          name='m_offline_intro_end'
          rows={4}
          defaultValue={values.widget_config?.messages?.m_offline_intro_end}
          ref={m_offline_intro_endRef}
          maxLength={300}
          onBlur={() =>
            checkValue(
              values.widget_config?.messages?.m_offline_intro_end,
              m_offline_intro_endRef
            )
          }
        />
      </section>

      <section className={classes.multiLineSection}>
        <label htmlFor='offline_submit'>Offline Submission</label>
        <textarea
          placeholder={`Thanks, <name>! We've saved your information and one of our helpful experts will be in touch as soon as possible.`}
          name='offline_submit'
          rows={4}
          defaultValue={values.widget_config?.messages?.offline_submit}
          ref={offline_submitRef}
          maxLength={300}
          onBlur={() =>
            checkValue(
              values.widget_config?.messages?.offline_submit,
              offline_submitRef
            )
          }
        />
      </section>
    </>
  )
}

export default ContentSection
